export const getIsAdmin = () => !!window.SESSION_USER?.isAdmin && !window.SESSION_USER.supportAdmin;
